module.exports = __webpack_public_path__ + "static/media/possessive-adjectives-spanish.ffd3e2c1.jpg";